import { Grid2X2, List } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../shadcn/ui/tooltip";

import { cn } from "@punchup/utils/cn";

interface Props {
  viewMode: "list" | "grid";
  onListClick: () => void;
  onGridClick: () => void;
  className?: string;
}

export default function ListGridViewButton({
  viewMode,
  onListClick,
  onGridClick,
  className,
}: Props) {
  return (
    <div
      className={cn(
        "flex flex-row gap-x-0.5 bg-[#f7f7f7] rounded-md",
        className
      )}
    >
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={onGridClick}
              className={cn(
                "hidden p-2 transition-colors rounded-md md:flex",
                viewMode === "grid"
                  ? "stroke-white bg-secondary-blue"
                  : "stroke-secondary-blue bg-[#f7f7f7]"
              )}
            >
              <Grid2X2 height={24} width={24} className="stroke-inherit" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Grid view</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={onListClick}
              className={cn(
                "hidden p-2 transition-colors rounded-md md:flex",
                viewMode === "list"
                  ? "stroke-white bg-secondary-blue"
                  : "stroke-secondary-blue bg-[#f7f7f7]"
              )}
            >
              <List height={24} width={24} className="stroke-inherit" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>List view</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
